







































































































































































































































































































































import { CancelTokenSource } from 'axios';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import Modal from '@/components/UI/Modal.vue';

import MmHintedButton from './MmHintedButton.vue';
import MmStates from './MmStates.vue';
import { fetchPhoto } from '../api/results';
import { createCancelSource } from '../api/mmHttp';
import { buildExportFileName, downloadBlob, readContentDispositionFileName } from '../core/download';
import { formatDateTime, MM_EMPTY_DASH, orDash } from '../core/format';
import { formatDiagnostics, isCanceled, MmError, toMmErrorAsync } from '../core/errors';
import { MmPhoto } from '../types/domain';

const KEY_PREFIX = 'priceMonitoring.mobileMonitoring.photos.';
const TASK_RESULTS_KEY = 'priceMonitoring.mobileMonitoring.taskResults.';

/** Значение должно совпадать с меткой секции в api/results.ts */
const PHOTO_SECTION = 'results/photo';

const PHOTO_CACHE_LIMIT = 24;

const ZOOM_MIN = 1;
const ZOOM_MAX = 4;
const ZOOM_STEP = 0.5;
const ROTATION_STEP = 90;
const FULL_TURN = 360;

/** Запасные коды клавиш — для браузеров без `KeyboardEvent.key`. */
const KEY_CODE_LEFT = 37;
const KEY_CODE_RIGHT = 39;
const KEY_CODE_PAGE_UP = 33;
const KEY_CODE_PAGE_DOWN = 34;

const EDITABLE_LOOKUP_DEPTH = 5;

/** Класс поискового поля `a-select` (ant-design-vue 1.7.8). */
const ANT_SELECT_SEARCH_CLASS = 'ant-select-search__field';

interface MmPhotoCacheEntry {
	/** object-URL обязан освобождаться через revokeObjectURL, встроенный data-URL — нет */
	objectUrl: string;
	blob: Blob;
	fileName: string | null;
	revocable: boolean;
	isFullResolution: boolean;
}

@Component({
	components: { Modal, MmHintedButton, MmStates },
})
export default class MmPhotoGallery extends Vue {
	@Prop({ required: true }) readonly visible!: boolean;

	@Prop({ default: () => [] }) readonly photos!: MmPhoto[];

	@Prop({ default: 0 }) readonly startIndex!: number;

	@Prop({ default: '' }) readonly title!: string;

	@Prop({ default: '' }) readonly auditor!: string;

	@Prop({ default: '' }) readonly capturedAtFallback!: string;

	@Prop({ default: '' }) readonly shootingLocation!: string;

	@Prop({ default: '' }) readonly positionCounter!: string;

	@Prop({ default: false }) readonly hasPrevPosition!: boolean;

	@Prop({ default: false }) readonly hasNextPosition!: boolean;

	@Prop({ default: '' }) readonly submittedPrice!: string;

	@Prop({ default: '' }) readonly correctedPrice!: string;

	@Prop({ default: '' }) readonly auditorPromo!: string;

	@Prop({ default: '' }) readonly auditorProductName!: string;

	@Prop({ default: '' }) readonly auditorBarCode!: string;

	@Prop({ default: '' }) readonly auditorOutcome!: string;

	@Prop({ default: '' }) readonly auditorSkipReason!: string;

	@Prop({ default: '' }) readonly auditorFoundKind!: string;

	@Prop({ default: false }) readonly showFoundKind!: boolean;

	@Prop({ default: false }) readonly showTpcSubcategory!: boolean;

	@Prop({ default: '' }) readonly auditorTpcSubcategory!: string;

	@Prop({ default: '' }) readonly auditorConfidence!: string;

	@Prop({ default: '' }) readonly auditorPriceSource!: string;

	@Prop({ default: '' }) readonly auditorPriceChecker!: string;

	@Prop({ default: false }) readonly showPriceChecker!: boolean;

	@Prop({ default: '' }) readonly auditorProductRecognized!: string;

	@Prop({ default: false }) readonly showProductRecognized!: boolean;

	@Prop({ default: '' }) readonly auditorCardPrice!: string;

	@Prop({ default: '' }) readonly auditorWholesalePrice!: string;

	/** От какого количества действует оптовая цена. */
	@Prop({ default: '' }) readonly auditorWholesaleVolume!: string;

	@Prop({ default: '' }) readonly auditorCompetitorSku!: string;

	@Prop({ default: '' }) readonly auditorPromoType!: string;

	@Prop({ default: '' }) readonly auditorCurrency!: string;

	/** Вес, габариты, характеристики строкой — как прочитало устройство. */
	@Prop({ default: '' }) readonly auditorVgh!: string;

	@Prop({ default: '' }) readonly auditorConfidenceName!: string;

	@Prop({ default: '' }) readonly auditorConfidencePromo!: string;

	@Prop({ default: '' }) readonly auditorConfidenceBarcode!: string;

	@Prop({ default: '' }) readonly auditorConfidenceVgh!: string;

	@Prop({ default: '' }) readonly auditorComment!: string;

	@Prop({ default: '' }) readonly gpsCoordinates!: string;

	@Prop({ default: '' }) readonly gpsMapsUrl!: string;

	index: number = 0;

	currentUrl: string | null = null;

	isLoading: boolean = false;

	/**
	 * 0 — отказа нет; 1 — первая неудача (предлагаем новую ссылку);
	 * 2 — не открылось и по новой ссылке (финальная заглушка).
	 */
	failureStage: number = 0;

	lastError: MmError | null = null;

	zoom: number = ZOOM_MIN;

	rotation: number = 0;

	panX: number = 0;

	panY: number = 0;

	isPanning: boolean = false;

	private cache: { [photoId: string]: MmPhotoCacheEntry } = {};

	/** Голова списка — самый давно использованный ключ, с него и вытесняем */
	private cacheOrder: string[] = [];

	/** Отслеживаем id, а не индекс: у соседней позиции индекс тот же, а снимок другой */
	private loadedPhotoId: string | null = null;

	private isKeyHandlerAttached: boolean = false;

	private panOriginX: number = 0;

	private panOriginY: number = 0;

	/** Кэш снимков намеренно нереактивен: перерисовку шаблона тянет этот счётчик */
	photoStateTick: number = 0;

	private views: { [photoId: string]: { zoom: number; rotation: number; panX: number; panY: number } } = {};

	private failureStageById: { [photoId: string]: number } = {};

	private errorById: { [photoId: string]: MmError | null } = {};

	private loadingById: { [photoId: string]: boolean } = {};

	private cancelSources: { [photoId: string]: CancelTokenSource } = {};

	get total(): number {
		return this.photos ? this.photos.length : 0;
	}

	get currentPhoto(): MmPhoto | null {
		if (this.total === 0) {
			return null;
		}

		const at = this.clampIndex(this.index);

		return this.photos[at] ? this.photos[at] : null;
	}

	get hasPhoto(): boolean {
		return this.currentPhoto !== null;
	}

	get isEmpty(): boolean {
		return this.total === 0;
	}

	get hasPrevPhoto(): boolean {
		return this.total > 1 && this.index > 0;
	}

	get hasNextPhoto(): boolean {
		return this.total > 1 && this.index < this.total - 1;
	}

	get showDots(): boolean {
		return this.total > 2;
	}

	get canPan(): boolean {
		return this.zoom > ZOOM_MIN && this.currentUrl !== null;
	}

	get canDownload(): boolean {
		const tick = this.photoStateTick;
		const photo = this.currentPhoto;

		if (photo === null || tick < 0) {
			return false;
		}

		const cached = this.cache[photo.id];

		return cached !== undefined && cached.objectUrl !== '';
	}

	get canRefreshLink(): boolean {
		return this.lastError !== null && this.lastError.retryable === true;
	}

	get refreshBlockedReason(): string {
		if (this.canRefreshLink) {
			return '';
		}

		const fromService = this.lastError !== null ? String(this.lastError.message).trim() : '';

		return fromService !== '' ? fromService : this.unavailableHintText;
	}

	get isQuarterTurned(): boolean {
		return this.rotation % 180 !== 0;
	}

	get imageStyle(): { [key: string]: string } {
		/** translate идёт первым: после rotate оси повёрнуты и сдвиг считался бы не в экранных пикселях */
		const transform =
			'translate(' +
			String(this.panX) +
			'px, ' +
			String(this.panY) +
			'px) rotate(' +
			String(this.rotation) +
			'deg) scale(' +
			String(this.zoom) +
			')';

		return { transform: transform };
	}

	get counterText(): string {
		return this.total > 1 ? this.buildCounter(this.index) : '';
	}

	get zoomText(): string {
		return String(Math.round(this.zoom * 100)) + '%';
	}

	get imageAlt(): string {
		const counter = this.buildCounter(this.index);

		return this.title !== '' ? this.title + ' — ' + counter : counter;
	}

	get capturedAtLabel(): string {
		return this.$t(KEY_PREFIX + 'capturedAt') as string;
	}

	get capturedAtText(): string {
		return this.capturedAtTextFor(this.currentPhoto);
	}

	capturedAtTextFor(photo: MmPhoto | null): string {
		if (photo !== null) {
			const fromPhoto = formatDateTime(photo.capturedAt);

			if (fromPhoto !== MM_EMPTY_DASH) {
				return fromPhoto;
			}
		}

		const fallback = this.capturedAtFallback ? String(this.capturedAtFallback).trim() : '';

		return fallback === '' ? MM_EMPTY_DASH : formatDateTime(fallback);
	}

	photoAt(position: number): MmPhoto | null {
		if (!this.photos || position < 0 || position >= this.photos.length) {
			return null;
		}

		return this.photos[position] ? this.photos[position] : null;
	}

	photoCounterText(position: number): string {
		return this.total > 1 ? this.buildCounter(position) : '';
	}

	photoZoomText(position: number): string {
		return String(Math.round(this.viewZoom(position) * 100)) + '%';
	}

	photoSrc(position: number): string | null {
		const tick = this.photoStateTick;
		const photo = this.photoAt(position);

		if (photo === null || tick < 0) {
			return null;
		}

		if (position === this.index && this.currentUrl !== null) {
			return this.currentUrl;
		}

		const cached = this.cache[photo.id];

		return cached ? cached.objectUrl : null;
	}

	isPhotoLoading(position: number): boolean {
		const tick = this.photoStateTick;
		const photo = this.photoAt(position);

		if (photo === null || tick < 0) {
			return false;
		}

		return this.loadingById[photo.id] === true;
	}

	photoFailureStage(position: number): number {
		const tick = this.photoStateTick;
		const photo = this.photoAt(position);

		if (photo === null || tick < 0) {
			return 0;
		}

		const stage = this.failureStageById[photo.id];

		return typeof stage === 'number' ? stage : 0;
	}

	canRefreshPhoto(position: number): boolean {
		const error = this.photoError(position);

		return error !== null && error.retryable === true;
	}

	photoRefreshBlockedReason(position: number): string {
		if (this.canRefreshPhoto(position)) {
			return '';
		}

		const error = this.photoError(position);
		const fromService = error !== null ? String(error.message).trim() : '';

		return fromService !== '' ? fromService : this.unavailableHintText;
	}

	photoDiagnosticsText(position: number): string {
		const error = this.photoError(position);

		return error === null ? '' : formatDiagnostics(error.diagnostics);
	}

	photoRefreshFailedText(position: number): string {
		const error = this.photoError(position);
		const requestId =
			error !== null && error.diagnostics.requestId !== null
				? error.diagnostics.requestId
				: MM_EMPTY_DASH;

		return this.$t(KEY_PREFIX + 'refreshFailed', { requestId: requestId }) as string;
	}

	photoImageAlt(position: number): string {
		const counter = this.buildCounter(position);

		return this.title !== '' ? this.title + ' — ' + counter : counter;
	}

	photoImageStyle(position: number): { [key: string]: string } {
		if (position === this.index) {
			return this.imageStyle;
		}

		const view = this.viewAt(position);
		const transform =
			'translate(' +
			String(view.panX) +
			'px, ' +
			String(view.panY) +
			'px) rotate(' +
			String(view.rotation) +
			'deg) scale(' +
			String(view.zoom) +
			')';

		return { transform: transform };
	}

	isPhotoQuarterTurned(position: number): boolean {
		return this.viewAt(position).rotation % 180 !== 0;
	}

	canPanPhoto(position: number): boolean {
		return this.viewZoom(position) > ZOOM_MIN && this.photoSrc(position) !== null;
	}

	isPanningPhoto(position: number): boolean {
		return this.isPanning && position === this.index;
	}

	handleZoomInAt(position: number): void {
		this.focusPhoto(position);
		this.handleZoomIn();
	}

	handleZoomOutAt(position: number): void {
		this.focusPhoto(position);
		this.handleZoomOut();
	}

	handleRotateAt(position: number): void {
		this.focusPhoto(position);
		this.handleRotate();
	}

	handleRefreshLinkAt(position: number): void {
		this.focusPhoto(position);

		if (!this.canRefreshPhoto(position)) {
			return;
		}

		const photo = this.photoAt(position);

		if (photo === null) {
			return;
		}

		this.loadPhoto(photo, true);
	}

	handleStageMouseDownAt(position: number, event: MouseEvent): void {
		this.focusPhoto(position);
		this.handleStageMouseDown(event);
	}

	get auditorLabel(): string {
		return this.$t(KEY_PREFIX + 'auditor') as string;
	}

	get shootingLocationLabel(): string {
		return this.$t(KEY_PREFIX + 'shootingLocation') as string;
	}

	get shootingLocationText(): string {
		return orDash(this.shootingLocation);
	}

	get auditorText(): string {
		return orDash(this.auditor);
	}

	get auditorDataTitle(): string {
		return this.$t(KEY_PREFIX + 'auditorData') as string;
	}

	get submittedPriceLabel(): string {
		return this.$t(KEY_PREFIX + 'submittedPrice') as string;
	}

	get promoLabel(): string {
		return this.$t(TASK_RESULTS_KEY + 'colPromo') as string;
	}

	get productNameLabel(): string {
		return this.$t(TASK_RESULTS_KEY + 'colProductName') as string;
	}

	get barCodeLabel(): string {
		return this.$t(TASK_RESULTS_KEY + 'colBarCode') as string;
	}

	get outcomeLabel(): string {
		return this.$t(TASK_RESULTS_KEY + 'colOutcome') as string;
	}

	get skipReasonLabel(): string {
		return this.$t(KEY_PREFIX + 'skipReason') as string;
	}

	get foundKindLabel(): string {
		return this.$t(TASK_RESULTS_KEY + 'colFoundKind') as string;
	}

	get tpcSubcategoryLabel(): string {
		return this.$t(TASK_RESULTS_KEY + 'colSubcategory') as string;
	}

	get confidenceLabel(): string {
		return this.$t(TASK_RESULTS_KEY + 'colConfidence') as string;
	}

	get priceSourceLabel(): string {
		return this.$t(TASK_RESULTS_KEY + 'colPriceSource') as string;
	}

	get priceCheckerLabel(): string {
		return this.$t(TASK_RESULTS_KEY + 'colPriceChecker') as string;
	}

	get productRecognizedLabel(): string {
		return this.$t(KEY_PREFIX + 'productRecognized') as string;
	}

	get cardPriceLabel(): string {
		return this.$t(KEY_PREFIX + 'cardPrice') as string;
	}

	get wholesalePriceLabel(): string {
		return this.$t(KEY_PREFIX + 'wholesalePrice') as string;
	}

	get wholesaleVolumeLabel(): string {
		return this.$t(KEY_PREFIX + 'wholesaleVolume') as string;
	}

	get competitorSkuLabel(): string {
		return this.$t(KEY_PREFIX + 'competitorSku') as string;
	}

	get promoTypeLabel(): string {
		return this.$t(KEY_PREFIX + 'promoType') as string;
	}

	get currencyLabel(): string {
		return this.$t(KEY_PREFIX + 'currency') as string;
	}

	get vghLabel(): string {
		return this.$t(KEY_PREFIX + 'vgh') as string;
	}

	get confidenceNameLabel(): string {
		return this.$t(KEY_PREFIX + 'confidenceName') as string;
	}

	get confidencePromoLabel(): string {
		return this.$t(KEY_PREFIX + 'confidencePromo') as string;
	}

	get confidenceBarcodeLabel(): string {
		return this.$t(KEY_PREFIX + 'confidenceBarcode') as string;
	}

	get confidenceVghLabel(): string {
		return this.$t(KEY_PREFIX + 'confidenceVgh') as string;
	}

	get auditorCommentLabel(): string {
		return this.$t(KEY_PREFIX + 'auditorComment') as string;
	}

	get gpsCoordinatesLabel(): string {
		return this.$t(KEY_PREFIX + 'gpsCoordinates') as string;
	}

	get gpsCoordinatesText(): string {
		return orDash(this.gpsCoordinates);
	}

	get gpsMapsTitle(): string {
		return this.$t(KEY_PREFIX + 'gpsMapsTitle') as string;
	}

	get cardPriceText(): string {
		return orDash(this.auditorCardPrice);
	}

	get wholesalePriceText(): string {
		return orDash(this.auditorWholesalePrice);
	}

	get wholesaleVolumeText(): string {
		return orDash(this.auditorWholesaleVolume);
	}

	get competitorSkuText(): string {
		return orDash(this.auditorCompetitorSku);
	}

	get promoTypeText(): string {
		return orDash(this.auditorPromoType);
	}

	get currencyText(): string {
		return orDash(this.auditorCurrency);
	}

	get vghText(): string {
		return orDash(this.auditorVgh);
	}

	get confidenceNameText(): string {
		return orDash(this.auditorConfidenceName);
	}

	get confidencePromoText(): string {
		return orDash(this.auditorConfidencePromo);
	}

	get confidenceBarcodeText(): string {
		return orDash(this.auditorConfidenceBarcode);
	}

	get confidenceVghText(): string {
		return orDash(this.auditorConfidenceVgh);
	}

	get auditorCommentText(): string {
		return orDash(this.auditorComment);
	}

	get emptyTitleText(): string {
		return this.$t(KEY_PREFIX + 'empty') as string;
	}

	get photoLoadingText(): string {
		return this.$t('priceMonitoring.mobileMonitoring.states.loading') as string;
	}

	get unavailableTitleText(): string {
		return this.$t(KEY_PREFIX + 'unavailable') as string;
	}

	get unavailableHintText(): string {
		return this.$t(KEY_PREFIX + 'unavailableHint') as string;
	}

	get refreshLinkText(): string {
		return this.$t(KEY_PREFIX + 'refreshLink') as string;
	}

	get refreshFailedText(): string {
		const requestId =
			this.lastError !== null && this.lastError.diagnostics.requestId !== null
				? this.lastError.diagnostics.requestId
				: MM_EMPTY_DASH;

		return this.$t(KEY_PREFIX + 'refreshFailed', { requestId: requestId }) as string;
	}

	get diagnosticsText(): string {
		return this.lastError === null ? '' : formatDiagnostics(this.lastError.diagnostics);
	}

	get zoomInText(): string {
		return this.$t(KEY_PREFIX + 'zoomIn') as string;
	}

	get zoomOutText(): string {
		return this.$t(KEY_PREFIX + 'zoomOut') as string;
	}

	get rotateText(): string {
		return this.$t(KEY_PREFIX + 'rotate') as string;
	}

	get prevPhotoText(): string {
		return this.$t(KEY_PREFIX + 'prevPhoto') as string;
	}

	get nextPhotoText(): string {
		return this.$t(KEY_PREFIX + 'nextPhoto') as string;
	}

	get prevResultText(): string {
		return this.$t(KEY_PREFIX + 'prevResult') as string;
	}

	get nextResultText(): string {
		return this.$t(KEY_PREFIX + 'nextResult') as string;
	}

	get prevPositionBlockedReason(): string {
		return this.$t(KEY_PREFIX + 'prevResultDisabled') as string;
	}

	get nextPositionBlockedReason(): string {
		return this.$t(KEY_PREFIX + 'nextResultDisabled') as string;
	}

	get downloadText(): string {
		return this.$t(KEY_PREFIX + 'download') as string;
	}

	get closeText(): string {
		return this.$t(KEY_PREFIX + 'close') as string;
	}

	dotTitle(position: number): string {
		return this.buildCounter(position);
	}

	/** Метод, а не геттер: слоты не реактивны, геттер запомнил бы отрисовку ещё закрытого окна */
	hasActionsSlot(): boolean {
		const scoped = this.$scopedSlots as { [key: string]: any };

		return !!this.$slots.actions || !!scoped.actions;
	}

	mounted(): void {
		if (this.visible) {
			this.handleOpened();
		}
	}

	beforeDestroy(): void {
		this.detachKeyHandler();
		this.stopPanning();
		this.cancelPendingRequest();
		this.revokeAll();
	}

	@Watch('visible')
	onVisibleChanged(next: boolean): void {
		if (next) {
			this.handleOpened();

			return;
		}

		this.handleClosed();
	}

	@Watch('photos')
	onPhotosChanged(): void {
		if (!this.visible) {
			return;
		}

		const kept = this.findLoadedPhotoIndex();

		if (kept !== -1) {
			this.index = kept;
			this.applyFocusView();
			this.syncFocusFromCache();
			this.loadAllPhotos(false);

			return;
		}

		this.views = {};
		this.goTo(this.startIndex, false);
	}

	private findLoadedPhotoIndex(): number {
		if (this.loadedPhotoId === null || !this.photos) {
			return -1;
		}

		for (let i = 0; i < this.photos.length; i += 1) {
			if (this.photos[i] && this.photos[i].id === this.loadedPhotoId) {
				return i;
			}
		}

		return -1;
	}

	@Watch('startIndex')
	onStartIndexChanged(): void {
		if (!this.visible) {
			return;
		}

		this.goTo(this.startIndex, false);
	}

	handleClose(): void {
		this.$emit('close');
	}

	handlePrevPhoto(): void {
		if (this.hasPrevPhoto) {
			this.goTo(this.index - 1, false);
		}
	}

	handleNextPhoto(): void {
		if (this.hasNextPhoto) {
			this.goTo(this.index + 1, false);
		}
	}

	handleSelectPhoto(position: number): void {
		this.goTo(position, false);
	}

	handlePrevPosition(): void {
		if (this.hasPrevPosition) {
			this.$emit('prev-position');
		}
	}

	handleNextPosition(): void {
		if (this.hasNextPosition) {
			this.$emit('next-position');
		}
	}

	handleRefreshLink(): void {
		if (!this.canRefreshLink) {
			return;
		}

		this.loadCurrent(true);
	}

	handleZoomIn(): void {
		const next = this.zoom + ZOOM_STEP;

		if (next > ZOOM_MIN && this.needsFullResolution()) {
			this.ensureFullResolution(() => {
				this.setZoom(next);
			});

			return;
		}

		this.setZoom(next);
	}

	handleZoomOut(): void {
		this.setZoom(this.zoom - ZOOM_STEP);
	}

	handleRotate(): void {
		this.rotation = (this.rotation + ROTATION_STEP) % FULL_TURN;
		this.panX = 0;
		this.panY = 0;
		this.persistFocusView();
	}

	handleDownload(): void {
		const photo = this.currentPhoto;

		if (photo === null) {
			return;
		}

		const entry = this.cache[photo.id];

		if (!entry || !entry.isFullResolution) {
			this.ensureFullResolution(() => {
				const loaded = this.cache[photo.id];

				if (loaded && loaded.isFullResolution) {
					downloadBlob(loaded.blob, this.resolveFileName(photo, loaded));
				}
			});

			return;
		}

		downloadBlob(entry.blob, this.resolveFileName(photo, entry));
	}

	/** Тело пустое намеренно: всю работу делают модификаторы .prevent и .stop в шаблоне */
	handleSuppressEvent(): void {
		return undefined;
	}

	/** Слушатели на document, а не на сцене: иначе отпускание мыши снаружи оставит снимок на курсоре */
	handleStageMouseDown(event: MouseEvent): void {
		if (!this.canPan || event.button !== 0) {
			return;
		}

		event.preventDefault();

		this.isPanning = true;
		this.panOriginX = event.clientX - this.panX;
		this.panOriginY = event.clientY - this.panY;

		document.addEventListener('mousemove', this.onDocumentMouseMove);
		document.addEventListener('mouseup', this.onDocumentMouseUp);
	}

	private goTo(next: number, force: boolean): void {
		this.persistFocusView();
		this.index = this.clampIndex(next);
		this.applyFocusView();

		const photo = this.currentPhoto;
		const nextId = photo === null ? null : photo.id;

		if (!force && nextId !== null && nextId === this.loadedPhotoId) {
			this.syncFocusFromCache();
			this.loadAllPhotos(false);
			this.scrollGroupIntoView(this.index);

			return;
		}

		if (force) {
			this.resetView();
			this.persistFocusView();
		}

		this.failureStage = 0;
		this.lastError = null;
		this.loadedPhotoId = nextId;
		this.syncFocusFromCache();

		if (force && photo !== null) {
			this.loadPhoto(photo, true);
			this.loadAllPhotos(false);
		} else {
			this.loadAllPhotos(false);
		}

		this.scrollGroupIntoView(this.index);
	}

	private needsFullResolution(): boolean {
		const photo = this.currentPhoto;

		if (photo === null || this.photoSrc(this.index) === null) {
			return false;
		}

		const cached = this.cache[photo.id];

		return cached !== undefined && cached.isFullResolution !== true;
	}

	private ensureFullResolution(onReady?: () => void): void {
		const photo = this.currentPhoto;

		if (photo === null) {
			return;
		}

		const cached = this.cache[photo.id];

		if (cached && cached.isFullResolution) {
			if (onReady) {
				onReady();
			}

			return;
		}

		this.loadPhoto(photo, false, onReady);
	}

	private loadAllPhotos(force: boolean): void {
		if (!this.photos || this.photos.length === 0) {
			this.isLoading = false;
			this.currentUrl = null;
			this.bumpPhotoState();

			return;
		}

		for (let i = 0; i < this.photos.length; i += 1) {
			this.loadPhoto(this.photos[i], force);
		}
	}

	private loadCurrent(force: boolean, onReady?: () => void): void {
		const photo = this.currentPhoto;

		if (photo === null) {
			this.isLoading = false;
			this.currentUrl = null;
			this.bumpPhotoState();

			return;
		}

		this.loadPhoto(photo, force, onReady);
	}

	private loadPhoto(photo: MmPhoto, force: boolean, onReady?: () => void): void {
		if (!photo || !photo.id) {
			return;
		}

		const photoId = photo.id;

		if (!force) {
			const cached = this.cache[photoId];

			if (cached && cached.isFullResolution) {
				this.touchCache(photoId);
				this.setPhotoLoading(photoId, false);
				this.setPhotoFailure(photoId, 0, null);
				this.syncFocusFromCache();
				this.bumpPhotoState();

				if (onReady) {
					onReady();
				}

				return;
			}

			if (this.cancelSources[photoId]) {
				return;
			}
		}

		this.cancelPhotoRequest(photoId);

		if (force || this.cache[photoId]) {
			this.dropFromCache(photoId);
		}

		const source = createCancelSource();
		const request = fetchPhoto(photoId, { cancelToken: source.token });

		this.cancelSources[photoId] = source;
		this.setPhotoLoading(photoId, true);
		this.setPhotoFailure(photoId, 0, null);
		this.syncFocusFromCache();
		this.bumpPhotoState();

		request
			.then((response) => {
				if (this.cancelSources[photoId] !== source) {
					return;
				}

				const blob = response.data as Blob;
				const objectUrl = window.URL.createObjectURL(blob);

				this.putInCache(photoId, {
					objectUrl: objectUrl,
					blob: blob,
					fileName: readContentDispositionFileName(response.headers),
					revocable: true,
					isFullResolution: true,
				});

				this.setPhotoFailure(photoId, 0, null);
				this.syncFocusFromCache();
				this.bumpPhotoState();

				if (onReady) {
					onReady();
				}
			})
			.catch((error) => {
				if (isCanceled(error)) {
					return undefined;
				}

				if (this.cancelSources[photoId] !== source) {
					return undefined;
				}

				return toMmErrorAsync(error, PHOTO_SECTION).then((mmError) => {
					if (this.cancelSources[photoId] !== source) {
						return;
					}

					this.setPhotoFailure(photoId, force ? 2 : 1, mmError);
					this.syncFocusFromCache();
					this.bumpPhotoState();
				});
			})
			.finally(() => {
				if (this.cancelSources[photoId] !== source) {
					return;
				}

				delete this.cancelSources[photoId];
				this.setPhotoLoading(photoId, false);
				this.syncFocusFromCache();
				this.bumpPhotoState();
			});
	}

	private cancelPhotoRequest(photoId: string): void {
		const source = this.cancelSources[photoId];

		if (source) {
			source.cancel();
			delete this.cancelSources[photoId];
		}
	}

	private cancelPendingRequest(): void {
		const ids = Object.keys(this.cancelSources);

		for (let i = 0; i < ids.length; i += 1) {
			this.cancelPhotoRequest(ids[i]);
		}
	}

	private putInCache(photoId: string, entry: MmPhotoCacheEntry): void {
		this.cache[photoId] = entry;
		this.touchCache(photoId);
		this.evictOverflow(photoId);
	}

	private touchCache(photoId: string): void {
		const at = this.cacheOrder.indexOf(photoId);

		if (at !== -1) {
			this.cacheOrder.splice(at, 1);
		}

		this.cacheOrder.push(photoId);
	}

	/** guard ограничивает число шагов длиной очереди, иначе цикл может не завершиться */
	private evictOverflow(keepId: string): void {
		const keep: { [id: string]: boolean } = {};

		keep[keepId] = true;

		const visible = this.visiblePhotoIds();

		for (let i = 0; i < visible.length; i += 1) {
			keep[visible[i]] = true;
		}

		let guard = this.cacheOrder.length;

		while (this.cacheOrder.length > PHOTO_CACHE_LIMIT && guard > 0) {
			guard -= 1;

			const oldest = this.cacheOrder.shift();

			if (oldest === undefined) {
				return;
			}

			if (keep[oldest]) {
				this.cacheOrder.push(oldest);

				continue;
			}

			this.dropFromCache(oldest);
		}
	}

	private dropFromCache(photoId: string): void {
		const entry = this.cache[photoId];

		if (entry) {
			if (entry.revocable) {
				window.URL.revokeObjectURL(entry.objectUrl);
			}
			delete this.cache[photoId];

			/** Только для отзываемых URL: одинаковые data:-URL совпадают и погасили бы чужой живой кадр */
			if (entry.revocable && this.currentUrl === entry.objectUrl) {
				this.currentUrl = null;
			}
		}

		const at = this.cacheOrder.indexOf(photoId);

		if (at !== -1) {
			this.cacheOrder.splice(at, 1);
		}
	}

	private revokeAll(): void {
		const ids = Object.keys(this.cache);

		for (let i = 0; i < ids.length; i += 1) {
			const entry = this.cache[ids[i]];

			if (entry.revocable) {
				window.URL.revokeObjectURL(entry.objectUrl);
			}
		}

		this.cache = {};
		this.cacheOrder = [];
		this.currentUrl = null;
	}

	private handleOpened(): void {
		this.attachKeyHandler();
		this.views = {};
		this.failureStageById = {};
		this.errorById = {};
		this.loadingById = {};
		this.loadedPhotoId = null;
		this.index = this.clampIndex(this.startIndex);
		this.applyFocusView();

		const opened = this.currentPhoto;

		this.loadedPhotoId = opened !== null ? opened.id : null;
		this.loadAllPhotos(false);
		this.scrollGroupIntoView(this.index);
	}

	private handleClosed(): void {
		this.detachKeyHandler();
		this.stopPanning();
		this.cancelPendingRequest();
		this.revokeAll();
		this.resetView();
		this.views = {};
		this.failureStageById = {};
		this.errorById = {};
		this.loadingById = {};

		this.failureStage = 0;
		this.lastError = null;
		this.isLoading = false;
		this.loadedPhotoId = null;
		this.photoStateTick += 1;
	}

	private setZoom(next: number): void {
		const clamped = Math.min(ZOOM_MAX, Math.max(ZOOM_MIN, next));

		if (clamped === this.zoom) {
			return;
		}

		this.zoom = clamped;

		if (clamped === ZOOM_MIN) {
			this.panX = 0;
			this.panY = 0;
		}

		this.persistFocusView();
	}

	private resetView(): void {
		this.zoom = ZOOM_MIN;
		this.rotation = 0;
		this.panX = 0;
		this.panY = 0;
	}

	private onDocumentMouseMove(event: MouseEvent): void {
		if (!this.isPanning) {
			return;
		}

		this.panX = event.clientX - this.panOriginX;
		this.panY = event.clientY - this.panOriginY;
	}

	private onDocumentMouseUp(): void {
		this.stopPanning();
	}

	private stopPanning(): void {
		if (this.isPanning) {
			this.persistFocusView();
		}

		this.isPanning = false;

		document.removeEventListener('mousemove', this.onDocumentMouseMove);
		document.removeEventListener('mouseup', this.onDocumentMouseUp);
	}

	private attachKeyHandler(): void {
		if (this.isKeyHandlerAttached) {
			return;
		}

		document.addEventListener('keydown', this.onDocumentKeydown);
		this.isKeyHandlerAttached = true;
	}

	private detachKeyHandler(): void {
		if (!this.isKeyHandlerAttached) {
			return;
		}

		document.removeEventListener('keydown', this.onDocumentKeydown);
		this.isKeyHandlerAttached = false;
	}

	private onDocumentKeydown(event: KeyboardEvent): void {
		if (!this.visible || this.isEventFromEditable(event)) {
			return;
		}

		const key = event.key ? String(event.key) : '';
		const code = event.keyCode;

		if (key === 'ArrowLeft' || code === KEY_CODE_LEFT) {
			this.handlePrevPhoto();
			event.preventDefault();

			return;
		}

		if (key === 'ArrowRight' || code === KEY_CODE_RIGHT) {
			this.handleNextPhoto();
			event.preventDefault();

			return;
		}

		if (key === 'PageUp' || code === KEY_CODE_PAGE_UP) {
			this.handlePrevPosition();
			event.preventDefault();

			return;
		}

		if (key === 'PageDown' || code === KEY_CODE_PAGE_DOWN) {
			this.handleNextPosition();
			event.preventDefault();

			return;
		}

		if (key === '+' || key === '=') {
			this.handleZoomIn();
			event.preventDefault();

			return;
		}

		if (key === '-' || key === '_') {
			this.handleZoomOut();
			event.preventDefault();
		}
	}

	/** Вверх по родителям вручную: closest есть не во всех браузерах, а className у SVG не строка */
	private isEventFromEditable(event: KeyboardEvent): boolean {
		let node: HTMLElement | null = event && event.target ? (event.target as HTMLElement) : null;
		let depth = 0;

		while (node && depth < EDITABLE_LOOKUP_DEPTH) {
			const tag = node.tagName ? String(node.tagName).toUpperCase() : '';

			if (tag === 'INPUT' || tag === 'TEXTAREA') {
				return true;
			}

			if (node.isContentEditable === true) {
				return true;
			}

			const className = typeof node.className === 'string' ? node.className : '';

			if (className.indexOf(ANT_SELECT_SEARCH_CLASS) !== -1) {
				return true;
			}

			node = node.parentElement;
			depth += 1;
		}

		return false;
	}

	private bumpPhotoState(): void {
		this.photoStateTick += 1;
	}

	private visiblePhotoIds(): string[] {
		const ids: string[] = [];

		if (!this.photos) {
			return ids;
		}

		for (let i = 0; i < this.photos.length; i += 1) {
			if (this.photos[i] && this.photos[i].id) {
				ids.push(this.photos[i].id);
			}
		}

		return ids;
	}

	private photoError(position: number): MmError | null {
		const photo = this.photoAt(position);

		if (photo === null) {
			return null;
		}

		const error = this.errorById[photo.id];

		return error ? error : null;
	}

	private viewAt(position: number): { zoom: number; rotation: number; panX: number; panY: number } {
		if (position === this.index) {
			return {
				zoom: this.zoom,
				rotation: this.rotation,
				panX: this.panX,
				panY: this.panY,
			};
		}

		const photo = this.photoAt(position);

		if (photo === null) {
			return { zoom: ZOOM_MIN, rotation: 0, panX: 0, panY: 0 };
		}

		return this.viewOf(photo.id);
	}

	private viewZoom(position: number): number {
		return this.viewAt(position).zoom;
	}

	private viewOf(photoId: string): { zoom: number; rotation: number; panX: number; panY: number } {
		const existing = this.views[photoId];

		if (existing) {
			return existing;
		}

		const fresh = { zoom: ZOOM_MIN, rotation: 0, panX: 0, panY: 0 };

		this.$set(this.views, photoId, fresh);

		return fresh;
	}

	private persistFocusView(): void {
		const photo = this.currentPhoto;

		if (photo === null) {
			return;
		}

		const view = this.viewOf(photo.id);

		view.zoom = this.zoom;
		view.rotation = this.rotation;
		view.panX = this.panX;
		view.panY = this.panY;
		this.bumpPhotoState();
	}

	private applyFocusView(): void {
		const photo = this.currentPhoto;

		if (photo === null) {
			this.resetView();

			return;
		}

		const view = this.viewOf(photo.id);

		this.zoom = view.zoom;
		this.rotation = view.rotation;
		this.panX = view.panX;
		this.panY = view.panY;
	}

	private syncFocusFromCache(): void {
		const photo = this.currentPhoto;

		if (photo === null) {
			this.currentUrl = null;
			this.isLoading = false;
			this.failureStage = 0;
			this.lastError = null;

			return;
		}

		const cached = this.cache[photo.id];

		this.currentUrl = cached ? cached.objectUrl : null;
		this.isLoading = this.loadingById[photo.id] === true;

		const stage = this.failureStageById[photo.id];

		this.failureStage = typeof stage === 'number' ? stage : 0;
		this.lastError = this.errorById[photo.id] ? this.errorById[photo.id] : null;
	}

	private setPhotoLoading(photoId: string, loading: boolean): void {
		this.$set(this.loadingById, photoId, loading);
	}

	private setPhotoFailure(photoId: string, stage: number, error: MmError | null): void {
		this.$set(this.failureStageById, photoId, stage);
		this.$set(this.errorById, photoId, error);
	}

	private focusPhoto(position: number): void {
		const next = this.clampIndex(position);

		if (next === this.index) {
			return;
		}

		this.persistFocusView();
		this.index = next;
		this.applyFocusView();

		const photo = this.currentPhoto;

		this.loadedPhotoId = photo !== null ? photo.id : null;
		this.syncFocusFromCache();
		this.scrollGroupIntoView(next);
	}

	private scrollGroupIntoView(position: number): void {
		this.$nextTick(() => {
			const wrap = document.querySelector(
				'.mm-photo-gallery-modal [data-gallery-group="' + String(position) + '"]',
			);

			if (wrap && (wrap as HTMLElement).scrollIntoView) {
				(wrap as HTMLElement).scrollIntoView({ block: 'nearest' });
			}
		});
	}

	private clampIndex(value: number): number {
		if (this.total === 0) {
			return 0;
		}

		const numeric = Number(value);

		if (isNaN(numeric)) {
			return 0;
		}

		return Math.min(this.total - 1, Math.max(0, Math.floor(numeric)));
	}

	private buildCounter(position: number): string {
		return this.$t(KEY_PREFIX + 'counter', {
			current: position + 1,
			total: this.total,
		}) as string;
	}

	private resolveFileName(photo: MmPhoto, entry: MmPhotoCacheEntry): string {
		if (entry.fileName !== null && entry.fileName !== '') {
			return entry.fileName;
		}

		return buildExportFileName('photo_' + photo.id, null, '.' + this.resolveExtension(entry.blob));
	}

	private resolveExtension(blob: Blob): string {
		const type = blob && blob.type ? String(blob.type).toLowerCase() : '';
		const at = type.indexOf('/');

		if (at === -1 || at === type.length - 1) {
			return 'jpg';
		}

		const subtype = type.slice(at + 1).split(';')[0].replace('+xml', '');

		if (subtype === '' || subtype === 'octet-stream') {
			return 'jpg';
		}

		return subtype === 'jpeg' ? 'jpg' : subtype;
	}
}
